import React, { useEffect, useState } from "react";
import { getBorrowedStockList, getBorrowedStockDetails } from "../../../services/ProductService";
import { Modal } from "react-bootstrap";
import TableLoaderEffect from "../../constant/TableLoader";

const BorrowedStock = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [borrowedSource, setBorrowedSource] = useState([]);
    const [filteredSource, setFilteredSource] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isLoadingSource, setIsLoadingSource] = useState(false);
    const [selectedSource, setSelectedSource] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");

    useEffect(() => {
        setIsLoading(true);
        getBorrowedStockList()
            .then((resp) => {
                setBorrowedSource(resp.data.data);
                setFilteredSource(resp.data.data); // Initialize filtered data
            })
            .catch((error) => {
                console.log(error.response.data.message);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    const handleSearchChange = (e) => {
        const query = e.target.value.toLowerCase();
        setSearchQuery(query);

        if (query) {
            const filtered = borrowedSource.filter((item) =>
                item.source__name.toLowerCase().includes(query)
            );
            setFilteredSource(filtered);
        } else {
            setFilteredSource(borrowedSource);
        }
    };

    const toggleModal = (prod_id = null) => {
        setIsModalOpen(!isModalOpen);
        if (prod_id) {
            setIsLoadingSource(true);
            getBorrowedStockDetails(prod_id)
                .then((resp) => {
                    setSelectedSource(resp.data.data);
                })
                .catch((error) => {
                    console.log(error.response.data.message);
                })
                .finally(() => {
                    setIsLoadingSource(false);
                });
        }
    };

    return (
        <>
            <div className="container-fluid">
                <div className="card">
                    <div className="card-body p-0">
                        <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                            <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                <h4 className="heading mb-0">Inventory Transfers (Borrowed & Lent stocks)</h4>
                                <div className="d-flex align-items-center">
                                    <div className="form-group me-4">
                                        <input
                                            type="search"
                                            name="search"
                                            className="form-control"
                                            placeholder="Search by Source"
                                            autoFocus
                                            value={searchQuery}
                                            onChange={handleSearchChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                    <thead>
                                        <tr>
                                            <th>Source</th>
                                            <th>Product Count</th>
                                            <th>Borrowed Stocks</th>
                                            <th>Lent Stock</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isLoading ? (
                                            <TableLoaderEffect colLength={5} />
                                        ) : filteredSource.length > 0 ? (
                                            filteredSource.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.source__name}</td>
                                                    <td><span>{item.product_count}</span></td>
                                                    <td><span>{item.total_borrowed_quantity}</span></td>
                                                    <td><span>{item.total_lent_quantity}</span></td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-primary btn-sm me-3"
                                                            onClick={() => toggleModal(item.source__id)}
                                                        >
                                                            View Details
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5">No Borrowed & Lent Source found!</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal className="modal fade" id="exampleModal3" scrollable={true} show={isModalOpen} onHide={() => toggleModal()}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="exampleModalLabel1">Borrowed Stock Details</h1>
                        <button type="button" className="btn-close" onClick={() => toggleModal()}></button>
                    </div>
                    <div className="modal-body">

                        <div className="table-responsive active-projects style-1">
                            <div id="customer-tblwrapper" className="dataTables_wrapper no-footer">
                                <table id="empoloyees-tbl1" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                    <thead>
                                        <tr>
                                            <th>Product</th>
                                            <th>Borrowed Qnt</th>
                                            <th>Lent Qnt</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isLoadingSource ? (
                                            <TableLoaderEffect colLength={3} />
                                        ) :
                                            selectedSource.map((item, index) => (
                                                <tr key={index}>
                                                    <td><span>{item.product__name}</span></td>
                                                    <td><span>{item.total_borrowed_quantity}</span></td>
                                                    <td><span>{item.total_lent_quantity}</span></td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default BorrowedStock;
